
import { mapGetters, mapMutations } from 'vuex';

export default {
    props: ['rwh', 'circle'],
    computed: {
        ...mapGetters('order', ['items', 'isDelivery', 'orders', 'lastSeenSubPage']),
        ...mapGetters(['routes']),
        ...mapGetters('supplier', ['isWhitelabel']),
        isRestaurant() {
            return this.$route.name === 'supplier-slug';
        },
        isCheckout() {
            return this.$route.name === 'checkout';
        },
        slug() {
            return this.$route.params.slug;
        },
        wasRestaurantChain() {
            return this.routes.from === 'supplier-chain-slug';
        },
        redirectWithHistory() {
            if (process.browser) {
                if (this.rwh) {
                    return this.rwh;
                }
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                return urlParams.get('rwh') ? true : false;
            }
            return false;
        },
        redirectTo() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            let redirectTo = urlParams.get('backRedirectTo') ? urlParams.get('backRedirectTo') : null;
            if (redirectTo && this.redirectWithHistory) {
                redirectTo += '?rwh=true';
            }
            return redirectTo;
        },
        marketplace() {
            let marketplace = null;
            if (typeof window !== 'undefined') {
                marketplace = localStorage.getItem('marketplace');
            }
            return marketplace;
        }
    },
    methods: {
        ...mapMutations('order', ['clearCart', 'saveOrder']),
        goBack() {
            if (this.redirectTo) {
                this.$nextTick(this.$router.push(this.redirectTo));
                return;
            }
            if (this.isWhitelabel) {
                this.$router.push('/');
                return;
            }
            if (this.lastSeenSubPage && this.isRestaurant) {
                this.$router.push(`/${this.lastSeenSubPage}`);
                return;
            }
            if (this.items.length && this.isRestaurant) {
                this.saveOrder({ key: this.slug, val: this.items });
                if (this.redirectWithHistory) {
                    this.$nextTick(this.$router.go(-1));
                } else {
                    this.$nextTick(this.$router.push('/happy-takeaway'));
                }
            } else if (this.isCheckout || this.redirectWithHistory) {
                this.$nextTick(this.$router.go(-1));
            } else {
                this.$nextTick(this.$router.push('/happy-takeaway'));
            }
        },
    },
};
